// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./RadioDot_deepSeaGreen.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.RadioInput.Controlled.Input {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
  height: inherit;
}
div.RadioInput.Controlled.Input > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
div.RadioInput.Controlled.Input > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
div.RadioInput.Controlled.Input > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
div.RadioInput.Controlled.Input > div.Radios > div.radio.inactive {
  color: #697588 !important;
  pointer-events: none;
}
div.RadioInput.Controlled.Input > div.Radios > div.radio div.checkable {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #E8E9F0;
  padding: 0;
  margin-right: 6px;
  border-radius: 50%;
  vertical-align: middle;
}
div.RadioInput.Controlled.Input > div.Radios > div.radio div.checkable.checked {
  background-size: 20px 20px;
  background: #01FF94 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 2px 2px;
  border: 1px solid #01FF94;
}
div.RadioInput.Controlled.Input > div.Radios > div.radio label {
  font-size: 12px;
  line-height: 12px;
  vertical-align: text-bottom;
}

div.ToggleInput {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
}
div.ToggleInput > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
div.ToggleInput > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
div.ToggleInput > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
div.ToggleInput > div.Toggles {
  height: 100%;
  width: 100%;
  margin-left: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: "Aeonik", sans-serif;
  border: 1px solid #D3D6DF;
  padding: 4px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 16px;
  color: #002E33;
  border-radius: 15px;
  padding: 0;
  overflow: hidden;
}
div.ToggleInput > div.Toggles > div.toggle {
  display: inline-block;
  background-color: #FFF;
  text-align: center;
  border-right: 1px solid #D3D6DF;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  height: 100%;
  line-height: 32px;
  cursor: pointer;
  font-weight: bold;
  color: #697588;
}
div.ToggleInput > div.Toggles > div.toggle:active {
  color: #002E33;
  background-color: #F5F6F9;
}
div.ToggleInput > div.Toggles > div.toggle.selected {
  color: #002E33;
  background-color: #F5F6F9;
}
div.ToggleInput > div.Toggles > div.toggle.inactive {
  color: #697588;
  background-color: #F5F6F9;
}
div.ToggleInput > div.Toggles > div.toggle:last-child {
  border-right: none;
}

.invalid {
  font-size: 12px;
  line-height: 12px;
  vertical-align: text-bottom;
  color: #D92D20;
}
.invalid span {
  width: 80%;
  margin: 0 0 0px 3px;
  max-width: 330px;
  word-wrap: break-word;
}
.invalid label {
  width: 80%;
  max-width: 330px;
  word-wrap: break-word;
  margin: 0 0 0px 3px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/ToggleInput/ToggleInput.scss","webpack://./src/client/Global/InputBase.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGA;ECiBE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;EFGb,eAAA;AAGF;ACmBE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;ADKF;ACUE;EACE,UA9BS;EA+BT,gBA/BS;ADuBb;ACWE;EACE,kBAAA;ADTJ;AAnBM;EACE,yBAAA;EACA,oBAAA;AAqBR;AAnBM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAqBR;AAnBM;EACE,0BAAA;EACA,6EAAA;EACA,yBAAA;AAqBR;AAlBM;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;AAoBR;;AAfA;ECjBE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;AF2Df;AClCE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;AD0DF;AC3CE;EACE,UA9BS;EA+BT,gBA/BS;AD4Eb;AC1CE;EACE,kBAAA;AD4CJ;AAzCE;ECEA,YAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cClDa;EFwCX,mBAAA;EACA,UAAA;EACA,gBAAA;AAqDJ;AAnDI;EACE,qBAAA;EACA,sBExCE;EFyCF,kBAAA;EACA,+BAAA;EACA,8BAAA;UAAA,sBAAA;EACA,YAAA;EACA,iBCpDQ;EDqDR,eAAA;EACA,iBAAA;EACA,cEHG;AFwDT;AAnDM;EACE,cEzDO;EF0DP,yBEFC;AFuDT;AAlDM;EACE,cE9DO;EF+DP,yBEPC;AF2DT;AAjDM;EACE,cEhBC;EFiBD,yBEZC;AF+DT;AAhDM;EACE,kBAAA;AAkDR;;AA7CA;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cExEI;AFwHN;AA/CI;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAiDN;AA/CI;EACE,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAiDN","sourcesContent":["@import '../../../Global/InputBase';\n@import \"../../../Global/Colors.scss\";\n\ndiv.RadioInput.Controlled.Input {\n  @include inputContainerRules;\n  height: inherit;\n\n  >div.Radios {\n    >div.radio {\n      &.inactive {\n        color: $Gray90 !important;\n        pointer-events: none;\n      }\n      div.checkable {\n        display: inline-block;\n        width: 12px;\n        height: 12px;\n        border: 1px solid $Gray30;\n        padding: 0;\n        margin-right: 6px;\n        border-radius: 50%;\n        vertical-align: middle;\n      }\n      div.checkable.checked {\n        background-size: 20px 20px;\n        background: $ElectricGreen url(RadioDot_deepSeaGreen.svg) no-repeat 2px 2px;\n        border: 1px solid $ElectricGreen;\n      }\n\n      label {\n        font-size: 12px;\n        line-height: 12px;\n        vertical-align: text-bottom;\n      }\n    }\n  }\n}\ndiv.ToggleInput {\n  @include inputContainerRules;\n\n  > div.Toggles {\n    @include inputInputRules;\n    border-radius: 15px;\n    padding: 0;\n    overflow: hidden;\n\n    > div.toggle {\n      display: inline-block;\n      background-color: $White;\n      text-align: center;\n      border-right: 1px solid $Gray50;\n      box-sizing: border-box;\n      height: 100%;\n      line-height: $inputHeight;\n      cursor: pointer;\n      font-weight: bold;\n      color: $Gray90;\n\n      &:active {\n        color: $DeepSeaGreen;\n        background-color: $Gray20;\n      }\n\n      &.selected {\n        color: $DeepSeaGreen;\n        background-color: $Gray20;\n      }\n\n      &.inactive {\n        color: $Gray90;\n        background-color: $Gray20;\n      }\n\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n}\n.invalid {\n  font-size: 12px;\n  line-height: 12px;\n  vertical-align: text-bottom;\n  color: $Red;\n    span {\n      width: 80%;\n      margin: 0 0 0px 3px;\n      max-width: 330px;\n      word-wrap:break-word;\n    }\n    label {\n      width: 80%;\n      max-width: 330px;\n      word-wrap: break-word;\n      margin: 0 0 0px 3px;\n    }\n}\n","@import '../Global/Colors';\n$inputHeight: 32px;\n$inputWidth: 50%;\n\n\n@mixin inputLabelRules {\n  position: absolute;\n  width: $inputWidth;\n  text-overflow: ellipsis;\n  height: 100%;\n  box-sizing: border-box;\n  line-height: $inputHeight;\n  font-weight: 700;\n  font-size: 12px;\n  color: $DeepSeaGreen;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@mixin inputContainerRules {\n  display: block;\n  margin: 8px 0;\n  position: relative;\n  width: 100%;\n  height: $inputHeight;\n  color: $DeepSeaGreen;\n\n  > span.Label {\n    @include inputLabelRules;\n  }\n\n  > span.Label + .Controlled {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n  }\n\n  > span.Label + .Controlled.CheckBoxInput {\n    margin-left: 225px;\n  }\n}\n\n@mixin inputInputRules {\n  height: 100%;\n  width: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  font-family: \"Aeonik\", sans-serif;\n  border: 1px solid $Gray50;\n  padding: 4px;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $DeepSeaGreen;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
